/**
 * Pure dialer input logic — no React, no DOM, CommonJS so it unit-tests in plain node
 * (client/src/dialpad-logic.test.js) while webpack/babel interop still lets TwilioDialer.jsx
 * `import { cleanPhoneInput }`. Single source of truth for turning whatever the user typed /
 * pasted / backspaced into a canonical dialable value (drops tel:/ext, preserves +, fixes the
 * "+ then 10 digits" trap that made AsYouType misread the country code).
 */
'use strict';

function cleanPhoneInput(raw) {
  if (!raw) return '';
  // Drop common URI prefixes / extension suffixes before extracting digits
  var s = String(raw)
    .replace(/^(tel:|callto:|sip:|sms:)/i, '')
    .replace(/(?:[xX]|ext\.?|extension)\s*\d+\s*$/i, '')
    .trim();
  // Preserve a leading + if present (anywhere — paste sometimes has spaces)
  var hasPlus = /^\s*\+/.test(s) || /\+(?=\d)/.test(s);
  var digits = s.replace(/\D/g, '');
  var out = hasPlus ? '+' + digits : digits;
  // Self-correct the common "+ then 10 digits" pattern (user typed/pasted +14086030548
  // minus the country code, or saved that way). Without this AsYouType reads +40 as
  // Romania and the dialer shows "+40 8603 0548" which won't dial.
  if (/^\+\d{10}$/.test(out)) out = '+1' + out.substring(1);
  return out;
}

module.exports = { cleanPhoneInput: cleanPhoneInput };
module.exports.default = cleanPhoneInput;
